// [목적] 운영자 페이지 React 앱 mount — packages/ui 테마 + 운영 콘솔 App
// [이유] M9 AdminPage — placeholder 를 RBAC 게이트 + 4탭 콘솔(App.tsx)로 교체
// [사이드 이팩트] apps/web 과 동일하게 packages/ui 의 createMuiTheme 적용
// [수정 시 고려사항] 권한 확인은 App.tsx(/auth/me) + BE RolesGuard 이중 — 여기엔 로직 추가 금지

import { CssBaseline, ThemeProvider } from '@mui/material';
import { createMuiTheme } from '@gangwoncanvas/ui';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';

const theme = createMuiTheme('light');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </StrictMode>,
);
